import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetClientesResponse } from './cliente.model';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  constructor(private http: HttpClient) {}
  
    public getClientes(): Observable<IGetClientesResponse> {
      const url = `${environment.baseURL}Cliente/GetClientes`;
      return this.http.get<IGetClientesResponse>(url);
    }
}
